import API from '../services/api';

let instance = null;
const api = new API();

export const EXPORT_ALL_URL = 'api/attribution/postbacks';
export const EXPORT_CHANGES_HISTORY_URL = 'api/attribution/partner-config-changes';

export default class PartnerConfigService {
    constructor() {
        if (!instance) {
            instance = this;
        }
        return instance;
    }

    exportAll(partnerId = null) {
        return api.getFile(EXPORT_ALL_URL, {
            method: 'POST',
            credentials: 'include',
            responseType: 'blob',
            body: {
                partner_id: partnerId,
            },
        });
    }

    exportChangesHistory({ partnerName, longname, platform, agencyId = null }) {
        const params = {
            partner_name: partnerName,
            longname,
            platform,
        };
        if (agencyId != null) params.agency_id = agencyId;

        return api.getFile(EXPORT_CHANGES_HISTORY_URL, {
            method: 'GET',
            credentials: 'include',
            responseType: 'blob',
            params,
        });
    }
}
